module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"skipQuestionListening":"Пропускать прослушивание вопроса"}}')
  delete Component.options._Ctor
}
